import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-[14px] border border-transparent bg-[hsl(var(--bg-input))] px-5 py-4 text-base text-[hsl(var(--text-primary))] transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[hsl(var(--text-secondary))] focus-visible:outline-none focus-visible:bg-[hsl(var(--bg-card))] focus-visible:border-[hsl(var(--accent-primary))] focus-visible:shadow-[0_0_0_4px_rgba(0,113,227,0.06)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      style={{
        transitionTimingFunction: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
      }}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
